import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=01db2e8a&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=01db2e8a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db2e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01db2e8a')) {
      api.createRecord('01db2e8a', component.options)
    } else {
      api.reload('01db2e8a', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=01db2e8a&scoped=true", function () {
      api.rerender('01db2e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/customer.vue"
export default component.exports